export default __webpack_public_path__ + "static/media/tool_item_blue4.a26cf7b3.png";